import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-save-dialog',
  template: `
    <div style="text-align: center; padding: 20px;">
      <div
        style="font-size: 40px; color: #a3c100; border: 2px solid #a3c100; border-radius: 50%; width: 50px; height: 50px; margin: 0 auto; display: flex; align-items: center; justify-content: center;"
      >
        ?
      </div>
      <p style="font-size: 16px; margin: 20px 0;">Möchten Sie Ihre Änderungen speichern?</p>
      <div style="display: flex; justify-content: center; gap: 10px;">
        <button mat-button (click)="save()" style="border: 1px solid #a3c100; color: #a3c100;">Speichern</button>
        <button mat-button (click)="revert()" style="border: 1px solid #a3c100; color: #a3c100;">
          Nicht Speichern
        </button>
        <button mat-button (click)="cancel()" style="border: 1px solid #a3c100; color: #a3c100;">Abbrechen</button>
      </div>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SaveDialogComponent {
  onSave: () => void;
  onRevert: () => void;
  onCancel: () => void;

  constructor() {}
  save() {
    if (this.onSave) {
      this.onSave();
    }
  }
  revert() {
    if (this.onRevert) {
      this.onRevert();
    }
  }
  cancel() {
    if (this.onCancel) {
      this.onCancel();
    }
  }
}
